import { Button, InputArea } from '@cloudflare/kumo';
import { useState } from 'react';
import { ICONS } from '../ui/icons';

type Props = {
  onSend: (text: string) => Promise<void> | void;
  onSuggest?: () => Promise<void> | void;
  disabled?: boolean;
  /** Rótulo de contexto (placeholder) para o textarea */
  contextName?: string;
};

/** Caixa de reply: textarea com Enter (Shift+Enter quebra), botões de mídia, sugestão IA e envio. */
export function ReplyInput({ onSend, onSuggest, disabled, contextName }: Props) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [suggesting, setSuggesting] = useState(false);

  const submit = async () => {
    const t = text.trim();
    if (!t || busy) return;
    setBusy(true);
    try {
      await onSend(t);
      setText('');
    } finally {
      setBusy(false);
    }
  };

  // O `Textarea` do Cloudscape entrega o teclado em `detail` (key/shiftKey).
  const handleKey = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  const suggest = async () => {
    if (!onSuggest || suggesting || busy) return;
    setSuggesting(true);
    try {
      await onSuggest();
    } finally {
      setSuggesting(false);
    }
  };

  return (
    <div className="inbox-reply" data-testid="inbox-reply">
      <InputArea label="Mensagem de resposta" onChange={(e) => setText(e.target.value)} onKeyDown={handleKey} placeholder={contextName ? `Responder para ${contextName}…` : 'Digite sua resposta…'} value={text} disabled={disabled} rows={3} />
      <div className="inbox-reply__actions">
        <div className="inbox-reply__media">
          <Button variant="ghost" shape="square" icon={ICONS.Plus} aria-label="Anexar imagem" disabled title={'Enviar imagem (em breve)'} />
          <Button variant="ghost" shape="square" icon={ICONS.Mic} aria-label="Anexar áudio" disabled title={'Enviar áudio (em breve)'} />
        </div>
        <div className="inbox-reply__send">
          {onSuggest && (
            <Button variant="secondary" icon={ICONS.Sparkle} onClick={suggest} disabled={suggesting || busy || disabled} data-testid="inbox-suggest">
              {suggesting ? 'Sugerindo…' : 'Sugerir resposta'}
            </Button>
          )}
          <Button variant="primary" onClick={submit} disabled={!text.trim() || busy || disabled} data-testid="inbox-send">
            {busy ? 'Enviando…' : 'Enviar'}
          </Button>
        </div>
      </div>
    </div>
  );
}
